<template>
  <el-container>
    <el-main style="padding: 0">
      <div>
        <view-table
            ref="viewTable"
            class="employTable"
            :filter="filter"
            :limits="limits"
            :columns-property="columnsProperty"
            module="basic"
            url="employees"
            @addOrEdit="addEditHandle"
            @select="selectHandle"
            @delete="deleteHandle"
            @reset="resetHandle">
          <template slot="otherBtn">
            <el-button v-if="limits.delAuth && selection.length" type="danger" @click="deleteBatch">批量删除</el-button>
            <el-upload
                style="float: left"
                action=""
                :http-request="importFile"
                :disabled="importLoading"
                :show-file-list="false">
              <el-button v-if="limits.importAuth" style="margin-left: 10px" :loading="importLoading" type="primary">导入出勤时间</el-button>
            </el-upload>
          </template>
          <template slot="adSearch">
            <el-form :inline="true" :model="filter" @submit.native.prevent @keyup.enter.native="loadData(1)">
              <el-form-item label="编号：">
                <el-input v-model.trim="filter.employeeNO" placeholder="请输入编号" clearable/>
              </el-form-item>
              <el-form-item label="姓名：">
                <el-input v-model.trim="filter.employeeName" placeholder="请输入姓名" clearable/>
              </el-form-item>
            </el-form>
          </template>
        </view-table>
        <!-- 编辑 -->
        <employee-edit ref="editEmployee" @save-success="loadData"/>
      </div>
    </el-main>
  </el-container>
</template>

<script>
  import ViewTable from "@/components/ViewTable.vue";
  import EmployeeEdit from "@/views/information/Employee/EmployeeEdit";
  import loginUtil from "@/util/loginUtil";
  export default {
    name: "EmployeeList",
    components: {
      ViewTable,
      EmployeeEdit,
    },
    data() {
      return {
        limits:{
          addAuth: this.$auth(119),
          editAuth: this.$auth(120),
          delAuth: this.$auth(121),
          importAuth:this.$auth(290),
        },
        importLoading: false,
        mainBoxHeight: 0,
        data: [],
        filterText: "",
        filter: {
          employeeName: "",
          departmentID: "",
          employeeNO: "",
        },
        columnsProperty:[
          {
            key:"gender",
            align:"center",
            render: (h, params) => {
              return h("span", params.row.gender ? "女" : "男");
            },
          },
          {
            key: "action",
            align: "center",
            width: 140,
            slot: "action",
            fixed: "right",
          },
        ],
        selection: [],
      };
    },

    methods: {
      addEditHandle(row) {
        this.$refs.editEmployee.open(row);
      },

      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },

      // 删除(单删、多删)
      deleteHandle(row) {
        console.log(row);
        let ids = [];
        ids.push(row.employeeID);
        this.$http.delete("basic", "employees", ids).then((res) => {
          if (res.success) {
            this.loadData();
            this.$message.success("删除成功");
          }
        });
      },

      // checkBox
      selectHandle(selection) {
        this.selection = selection;
        console.log(this.selection);
      },
      //考勤时间导入
      importFile(params) {
        this.importLoading = true;
        let formData = new FormData(); //  用FormData存放上传文件
        formData.append("file", params.file);
        formData.append("Authorization", loginUtil.getToken());
        this.$http
          .post("basic", "employees/importAttendanceTime", formData)
          .then((res) => {
            if (res.success) {
              this.$message.success("上传成功");
            }
            this.importLoading = false;
          })
          .catch(() => {
            this.importLoading = false;
          });
      },
      // 批量删除员工
      deleteBatch() {
        var ids = [];
        this.selection.forEach((item) => {
          ids.push(item.employeeID);
        });
        this.$confirm("确定删除吗?", "提示", { type: "warning" }).then(() => {
          this.$http.delete("basic", "employees/idList", ids).then((resp) => {
            if (resp.success) {
              this.loadData(1);
              this.$message.success("删除成功");
              this.selection = [];
            }
          });
        });
      },
      // 重置
      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
      },
    },
  };
</script>
<style scoped>
</style>

<style>
</style>
